// extracted by mini-css-extract-plugin
export default {"inputs":"WCw1GA02E5F0oVsbr7s2","date":"ZVz0FzLGTAXLYEbCa7GV","time":"rH5y0AIWnf19fg1jGNMz"};